<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <!-- <a-tabs @change="callback">
        <a-tab-pane :key="0" tab="总部"></a-tab-pane><QuestionCircleOutlined />
        <a-tab-pane :key="1" tab="经销商"></a-tab-pane>< />
      </a-tabs> -->
      <a-radio-group class="m-b-20" v-model:value="search.lately_time" button-style="solid" @change='selectDay'>
        <a-radio-button value="">全部</a-radio-button>
        <a-radio-button :value="1">今天</a-radio-button>
        <a-radio-button :value="2">昨天</a-radio-button>
        <a-radio-button :value="3">近7天</a-radio-button>
        <a-radio-button :value="4">近30天</a-radio-button>
        <a-radio-button :value="5">自定义时间</a-radio-button>
      </a-radio-group>
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" v-if="search.lately_time==5" />
      <p></p>
      <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="" name='keywords'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
              <a-select-option value="order_no">订单编号</a-select-option>
              <a-select-option value="name">收货人姓名</a-select-option>
              <a-select-option value="phone">收货人手机</a-select-option>
              <a-select-option value="product_name">商品名称</a-select-option>
              <a-select-option value="buyer_name">买家姓名</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class="m-r-10">搜索</a-button>
          <a-button v-has:channelOrderShipExport="exportTable" class="m-r-10">导出</a-button>
          <a-button type="primary" v-has:channelOrderShipImport="()=>{visibleShipping=true}" class="m-r-10">从物流模板导入信息</a-button>
          <a-button type="primary" class="m-r-10" v-has:downImportTemplate="downTemplate">下载导入模板</a-button>
          <a-tooltip placement='right'>
            <template #title>
              一、模板中配送方式请输入数字，数字1代表快递发货，数字2代表当面交易<br />

              二、配送方式输入1，需填写正确的物流公司和物流单号，导入后无法修改，没有填写完整则导入失败<br />

              三、配送方式输入2，无需填写物流公司和物流单号，否则导入失败
            </template>
            <QuestionCircleOutlined class="s_c376" />
          </a-tooltip>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' rowKey='id' :columns='columns' :data-source='list' class="tableFixBox" :scroll="{ x: 'max-content'}">
        <template #expandedRowRender="{ record }">
          <a-table :pagination='false' :loading='listLoading' rowKey='goods_name' :columns='goodsColumns' :data-source='record.order_goods'>
            <template #title> <span class="m-r-20 p-l-16">订单号：{{record.order_sn}}</span> <span class="m-r-5"> 下单时间：{{record.create_time}}</span>（{{record.dealer_name}}）</template>
            <template v-slot:goods="{ record }">
              <a-card-meta>
                <template #avatar>
                  <img :src="info.picdomain+'/'+(record.goods_image)" alt="" style="width:50px;height:50px">
                </template>
                <template #description>
                  <p class="s_omit2" style="width: 320px;">{{record.goods_name}}</p>
                </template>
              </a-card-meta>

            </template>
            <template v-slot:status_text="{ record }">
              <a :href="'/order/channelOrder/chanelAfterSale/refund?refund_id='+record.refund_id" target="_blank">{{record.status_text}}</a>
            </template>
          </a-table>
        </template>

        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a href="javascript:;" v-has:channelOrderShipDetail="()=> {$router.push('/order/channelOrder/orderSearch/detail?id='+record.order_sn)}">详情</a>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:channelOrderShipShip="()=>orderDeliver(record,3)" href="javascript:;">发货</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" :show-total="total => `总数: ${total} `" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
    </a-card>
  </a-layout>
  <a-modal :title="deliverType == 1 ?'标记发货':'修改发货'" :width='1300' centered :footer="null" v-model:visible="showDeliver" destroyOnClose>
    <deliverForem :deliverData='deliverData' :type='deliverType' v-on:submitdeliver='submitdeliver'></deliverForem>
  </a-modal>
  <a-modal :keyboard="false" centered title="批量发货" v-model:visible="visibleShipping" :width='800' :footer="null" destroyOnClose>
    <a-card :bordered="false">
      <a-upload-dragger v-model:fileList="fileList" name="file" :multiple="false" :action="action" :headers="
            {
               Authorization:getToken()
            }" @change="handleChange">
        <p class="ant-upload-drag-icon">
          <inbox-outlined></inbox-outlined>
        </p>
        <p class="ant-upload-text">点击上传或者拖拽上传</p>
      </a-upload-dragger>
      <p style="color:#f04635">{{uploadStatus}}</p>
    </a-card>
  </a-modal>
</template>
<script>
import {
  DownOutlined,
  InboxOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import config from "@/config";
import { getToken } from "@/libs/util";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import {
  orderAddressMore,
  getChannelOrderShip,
  channelOrderDelivery,
  downloadExportModel,
  onlineOrderImport,
} from "@/api/order";
import { iscode } from "@/utils/app";
import { userExportTable } from "@/hooks/userExportTable";
import store from "@/store";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 5,
  store_type: 0,
  lately_time: "",
  start_time: "",
  end_time: "",
  key_type: "order_no",
  keyword: "",
};
export default {
  components: { DownOutlined, InboxOutlined, QuestionCircleOutlined },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let list = ref([]);
    const state = reactive({
      uploadStatus:'',
      fileList:[],
      action: onlineOrderImport(),
      visibleShipping: false, //导入 弹框
      dealer_id: "",
      deliverType: 1,
      info: store.state.user.info,
      orderRemarks: "",
      orderId: "",
      provinceList: [],
      cityList: [],
      open: false,
      showAddress: false,
      showDeliver: false,
      listLoading: false,
      showRemarks: false,
      showStore: false,
      showDealer: false,
      time: [],
      total: 1,
      selectedRowKeys: [],
      addressData: {},
      deliverData: {},
      refundsData: {},
      confirmLoading: false,
    });
    let columns = ref([
      {
        title: "收货人",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "联系方式",
        dataIndex: "mobile",
        key: "mobile",
      },
      {
        title: "联系地址",
        dataIndex: "address",
        key: "address",
      },
      {
        title: "支付积分",
        dataIndex: "pay_point",
        key: "pay_point",
        align: "center",
      },
      {
        title: "配送方式",
        dataIndex: "delivery_type_text",
        key: "delivery_type_text",
        align: "center",
      },
      {
        title: "订单状态",
        dataIndex: "order_status_text",
        key: "order_status_text",
        align: "center",
      },
      {
        title: "操作",
        key: "action",
        fixed:"right",
        slots: { customRender: "action" },
      },
    ]);
    const goodsColumns = [
      {
        title: "商品名称",
        dataIndex: "goods",
        key: "goods",
        slots: { customRender: "goods" },
      },
      {
        title: "规格",
        dataIndex: "goods_sku_name",
        key: "goods_sku_name",
      },
      {
        title: "数量",
        dataIndex: "goods_num",
        key: "goods_num",
        width: 100,
      },
      {
        title: "支付积分",
        dataIndex: "total_point_price",
        key: "total_point_price",
        width: 100,
      },
      {
        title: "退款状态",
        dataIndex: "status_text",
        key: "status_text",
        slots: { customRender: "status_text" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 切换订单类型
    const selectOrderType = () => {
      search.value.pay_type = "";
      search.value.rebate_type = "";
    };
    // 切换天数
    const selectDay = (e) => {
      search.value.page = 1;
      search.value.time = [];
      search.value.start_time = "";
      search.value.end_time = "";
      initData(search.value);
    };
    // 切换总部/门店
    const callback = (e) => {
      search.value.store_type = e;
      search.value.page = 1;
      initData(search.value);
    };

    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData(search.value);
    };
    //批量选中
    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys;
    };

    //获取列表
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getChannelOrderShip(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          console.log(res)
          list.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    //打开发货弹窗
    const orderDeliver = (e, type) => {
      if (e.is_delivery == 0) {
        message.error("订单中含有退款中商品，请处理！");
        return;
      }
      state.deliverType = type;
      state.deliverData = e;
      state.showDeliver = true;
    };
    //发货
    const submitdeliver = async (e) => {
      let result = await channelOrderDelivery({
        order_no: state.deliverData.order_sn,
        delivery_type: e.delivery_type,
        express_name: e.express_name,
        express_no: e.express_no,
        remark: e.store_remark,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result,true)) {
        state.showDeliver = false;
        initData(search.value);
      }
    };

    const inputSelect = (e) => {
      search.value.keyword = "";
    };

    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      initData(search.value);
    });

    // 导出
    const exportTable = async () => {
      const hide = message.loading("正在加载中...", 0);
      let result = await getChannelOrderShip({
        ...search.value,
        limit: 5000,
        excel: 1,
      })
        .then((res) => res.data)
        .catch((error) => error);
      setTimeout(hide);
      console.log(result);
      if (iscode(result, true)) {
        window.open(
          config.onlineOrderUrl[process.env.VUE_APP_type] +
            "download?key=" +
            result.data.key
        );
      }
    };
    // 下载导入模板
    const downTemplate=async()=>{
       let result=await downloadExportModel().then(res=>res.data).catch(error=>error)
       var key=result.data.key
       window.open(config.onlineOrderUrl[process.env.VUE_APP_type]+'download?key='+key)
    }
   const handleChange=(e)=>{
     state.uploadStatus=''
      if (e.file.status != 'removed') {
             if(e.file.response&&e.file.response.code){
        if(e.file.response.code==0){
          message.success('成功')
        }else{
          if(e.fileList.length){
            message.error(e.file.response.msg)
          e.fileList[e.fileList.length-1].status='error'
          state.uploadStatus=e.file.response.msg
          return false
          }
        }
      }
    }
   }
    return {
      ...toRefs(state),
      search,
      list,
      columns,
      goodsColumns,
      getToken,
      handleChange,
      exportTable,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      onSelectChange,
      callback,
      selectDay,
      inputSelect,
      orderDeliver,
      submitdeliver,
      selectOrderType,
      downTemplate,
    };
  },
};
</script>